import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PACKS_NOT_SAVED_CHANGES_FEATURE_KEY,
  PackNotSavedChangesEntity,
  packsNotSavedChangesAdapter,
} from './packs-not-saved-changes.reducer';
import { EntityState } from '@ngrx/entity';
import { Dictionary } from '@ngrx/entity/src/models';

const { selectEntities, selectTotal } = packsNotSavedChangesAdapter.getSelectors();

const getPacksNotSavedChangesFeatureState = createFeatureSelector<EntityState<PackNotSavedChangesEntity>>(
  PACKS_NOT_SAVED_CHANGES_FEATURE_KEY
);
// eslint-disable-next-line
export const getPacksNotSavedChangesEntities = () =>
  createSelector(getPacksNotSavedChangesFeatureState, (state: EntityState<PackNotSavedChangesEntity>) =>
    selectEntities(state)
  );
// eslint-disable-next-line
export const getPacksNotSavedChangesTotal = () =>
  createSelector(getPacksNotSavedChangesFeatureState, (state: EntityState<PackNotSavedChangesEntity>) =>
    selectTotal(state)
  );
// eslint-disable-next-line
export const getNotSavedChangesForPak = (pakId: string) =>
  createSelector(
    getPacksNotSavedChangesEntities(),
    (entities: Dictionary<PackNotSavedChangesEntity>) => entities[pakId]
  );
